module.exports = __webpack_public_path__ + "static/media/game-bosstalkingright.6178b8d6.png";